import { Fragment } from "react";

import MenuItem from "@mui/material/MenuItem";

import MySelectField from "components/Inputs/MySelectField";

const VehicleColorSelect = (props) => {
  const { value, updateValues, vehicleColors } = props;

  const handleSelectChange = ({ target }) => {
    updateValues({ [target.name]: target.value });
  };

  return (
    <Fragment>
      {vehicleColors && vehicleColors.length > 0 ? (
        <MySelectField
          id="select_order_type"
          name="color"
          value={value ? value : "#151715"}
          onChange={handleSelectChange}
        >
          {vehicleColors.map((option) => (
            <MenuItem key={option.key} value={option.key}>
              {option.value}
            </MenuItem>
          ))}
        </MySelectField>
      ) : null}
    </Fragment>
  );
};

export default VehicleColorSelect;
